import request from '@/utils/request'
import api from './base-url.config'
import { getUrlKey } from '@/utils'
import store from '@/store/index'
const headers = {
  'sysCode': getUrlKey('sysCode') || 'ICAS'
}

/**
 * 授权重定向
 * @param {} params
 * @returns
 */
export function authRedirectApi(params) {
  return request({
    url: api.authRedirect,
    method: 'get',
    params
  })
}
/**
 * 获取第三方登录配置
 * @param {} params
 * @returns
 */
export function thirdLoginConfig(params) {
  return request({
    url: api.thirdLoginConfig,
    method: 'get',
    params
  })
}
/**
 * 转换token 拼接到 redirectUrl并跳转
 * @param {*} params
 * @returns
 */
export function replaceTokenRedirectApi(params) {
  let query = ''
  for (const key in params) {
    query += `${key}=${params[key]}&`
  }
  // debugger
  // const query = querystring.stringify({
  //   redirectUrl: params.redirectUrl,
  //   token: store.getters.access_token
  // })
  return request({
    url: api.replaceTokenRedirect + '?' + query,
    method: 'get'
  })
}

export function replaceTokenRedirectApiWithQuery(params) {
  let query = ''
  for (const key in params) {
    query += `${key}=${params[key]}&`
  }
  // debugger
  // const query = querystring.stringify({
  //   redirectUrl: params.redirectUrl,
  //   token: store.getters.access_token
  // })
  return request({
    url: api.replaceTokenRedirectToken + '?' + query,
    method: 'get'
  })
}

export function replaceTokenRedirectTokenApi(params) {
  return request({
    url: api.replaceTokenRedirectToken,
    method: 'get',
    params
  })
}
export function productUrl(params) {
  return request({
    url: api.productUrl,
    method: 'get',
    params
  })
}

/**
 * 获取sso跳转白名单
 */
export function whitelistApi() {
  return request({
    url: api.whitelist,
    method: 'get'
  })
}

// 检查是否出现重复账号
export function accountDupCheckApi(params) {
  return request({
    url: api.accountDupCheck,
    method: 'get',
    params
  })
}

export function accountDupCheckV2Api(data) {
  return request({
    url: api.accountDupCheckV2,
    method: 'post',
    data
  })
  // .then(res => {
  //   return Promise.resolve({
  //     data: [
  //       {
  //         status: 1,
  //         weakFlag: true,
  //         isolateFlag: true,
  //         accountName: '18674027067',
  //         codeHash: 'c0ee4b1ba59204f8ebb1e53e0744f117',
  //         type: 1,
  //         phoneCode: 86,
  //         phoneCountry: 'CN',
  //         unregisterDate: null,
  //         sessionTicket: 'st_0f537fb43fc7420faf1a4c8886413503',
  //         crashFlag: null,
  //       }
  //     ]
  //   })
  // })
}

export function savePhoneAccountAbnormality(data) {
  return request({
    url: api.savePhoneAccountAbnormality,
    method: 'post',
    data
  })
}
/**
 * 检测token是否失效接口
 */
export function checkToken() {
  return request({
    baseURL: (process.env.VUE_APP_BASE_API || ''),
    url: api.checkToken,
    method: 'get'
  })
}

/**
 * 获取用户最新信息
 */
// export function updateUserInfo(params) {
//   return request({
//     url: api.updateUserInfo,
//     method: 'get',
//     params
//   })
// }

/**
 * 根据国家二字码获取国家电话规则
 * @param {string} countryCode 国家二字码
 * @returns {Object}
 */
export function publicQueryPhoneRuleApi(params) {
  return request({
    url: api.publicQueryPhoneRule,
    method: 'get',
    params
  })
}

/**
 * 手机验证码
 * @type {string} 短信业务码 	登录：login 重置密码：resetPassword 注册：register 修改密码：changePassword
 * 修改手机：modifyPhone，修改邮箱：modifyMail，绑定手机：bindPhone，绑定邮箱：bindMail
 * @data {string} phoneCountry 国家二字码
 * @data {string} phoneCode 手机区号
 * @data {string} phoneNumber 手机号码
 * @data {Object}
 */
export function sendSmsCodeApi(data, otherHeader) {
  let obj = null
  if (otherHeader) {
    obj = Object.assign({}, otherHeader, { useCaptcha: 1 })
  } else {
    obj = Object.assign({}, headers, { useCaptcha: 1 })
  }
  return request({
    url: api.sendSmsCode,
    method: 'post',
    headers: obj,
    data
  })
}
/**
 * 腾讯验证码方案-手机验证码

 */
export function sendTencentSmsCodeApi(data, otherHeader) {
  if (otherHeader) {
    otherHeader = Object.assign({}, otherHeader, { 'shouldShowToast': true })
  }
  return request({
    url: api.sendTencentSmsCode,
    method: 'post',
    headers: otherHeader || headers,
    data
  })
}

/**
 * 邮箱验证码
 * @type {string} 短信业务码  登录：login 重置密码：resetPassword   注册：register 修改密码：changePassword
 * 修改手机：modifyPhone，修改邮箱：modifyMail，绑定手机：bindPhone，绑定邮箱：bindMail
 * @data {string} mailTo 目的地邮箱号
 * @returns {Object}
 */
export function sendEmailCodeApi(data) {
  return request({
    url: api.sendEmailCode,
    method: 'post',
    headers: Object.assign({}, headers, { useCaptcha: 1 }),
    data
  })
}
/**
 * 腾讯验证码方案-邮箱验证码
 */
export function sendTencentEmailCodeApi(data) {
  return request({
    url: api.sendTencentEmailCode,
    method: 'post',
    headers,
    data
  })
}

/**
 * 检验手机验证码或者邮箱验证码是否正确
 * @type {string} 短信业务码 	登录：login 重置密码：resetPassword 注册：register 修改密码：changePassword
 * 修改手机：modifyPhone，修改邮箱：modifyMail，绑定手机：bindPhone，绑定邮箱：bindMail
 * @returns {Object}
 */
export function checkValidateCodeApi(data) {
  return request({
    url: api.checkValidateCode,
    method: 'post',
    data
  })
}

/**
* 获取滑动验证码图片
* @params {string} requestId 请求码
* @returns {Object}
*/
export function slideCircusApi(params) {
  return request({
    url: api.slideCircus,
    method: 'get',
    params
  })
}

/**
 * 灰度接口
 * 参考:https://confluence.sf-express.com/pages/viewpage.action?pageId=317339522
 * @param params
 */
export function slidePolicyApi(params) {
  return request({
    url: api.slidePolicy,
    method: 'get',
    params
  })
}

export function slideEmailPolicy(params) {
  return request({
    url: api.slideEmailPolicy,
    method: 'get',
    params
  })
}

/**
* 获取最新可用条款文件id
* @params {string} type 数据字典 条款类型
* @returns {Object}
*/
export function getLatestTermRichTextApi(params, disableError = false) {
  // debugger
  let country
  try {
    if (params?.country) {
      country = params.country
    } else {
      country = store.getters.site.siteConfig.country ?? getUrlKey('siteCountryCode')
    }
  } catch (e) {
    console.log(e)
  }
  return request({
    url: api.getLatestTermRichText,
    method: 'get',
    headers: {
      disableError: disableError ? 1 : 0,
      customedHeaderLang: params.lang
    },
    params: {
      ...params,
      country
    }
  })
}

/**
 * 根据字典名称获取相应的下拉数据
 * @param {String} name 字典名称
 */
// export function getDictApi(params) {
//   return request({
//     url: api.getDict,
//     method: 'get',
//     params: params
//   })
// }

/**
 * 获取解密字段
 * @param {String} cipherText 加密信息
 */
export function decrypt(data) {
  return request({
    url: api.decrypt,
    method: 'post',
    data
  })
}

/**
 * 腾讯图形验证码校验
 * @param {*} data
 * @returns
 */
export function checkTencentCaptcha(data) {
  return request({
    url: api.checkTencentCaptcha,
    method: 'post',
    data
  })
}

export function getPageRouteApi(params) {
  return request({
    url: api.getPageRoute,
    method: 'get',
    params
  })
}

// 字典
export function getDictionaryApi(params, otherHeaders = {}) {
  return request({
    url: api.dictionary,
    method: 'get',
    headers: Object.assign({}, headers, otherHeaders), // todo 应该heeaders没什么用
    params
  })
}

export function getSfbuyNotice(data) {
  return request({
    url: api.getSfbuyNotice,
    method: 'get',
    headers: { 'Cookie': 'lang=' + store.getters.language }, // todo 应该heeaders没什么用
    data
  })
}

// 蓝绿刷新接口
export function checkGrayVersion(params) {
  return request({
    url: api.checkGrayVersion,
    method: 'get',
    params
  })
}

export function getHomeNotice(data) {
  return request({
    url: api.getHomeNotice + `?country=${data.country}&lang=${data.lang}`,
    method: 'get',
    headers: { 'Cookie': 'lang=' + store.getters.language }, // todo 应该heeaders没什么用
    data
  })
}

/**
 *
 * https://confluence.sf-express.com/pages/viewpage.action?pageId=354454807
 * @param {*} params
 * country	国家地区二字码(注意港澳和CN并列) e.g.(CN,HK,TW,US)
 * phoneCode	电话国家区号（注意，不带+） e.g. 86,852,1
 * @returns
 */
export function getSmsNoticeChannel(params) {
  return request({
    url: api.getSmsNoticeChannel,
    method: 'get',
    params
  })
}
